import { useCustomerOrders } from '@backpackjs/storefront';

import AccountLayout from '../../../layouts/AccountLayout';
import { Headline, Spinner } from '../../../snippets';
import { OrdersItem } from './OrdersItem';

export function Orders() {
  const { getNext, getPrevious, hasNext, hasPrevious, orders, ...status } =
    useCustomerOrders({ perPage: 10 });

  const headers = ['Order', 'Date', 'Order Status', 'Total', 'Tracking'];

  return (
    <AccountLayout>
      <div className="flex flex-col gap-8 text-[#202635] md:gap-10">
        <Headline variant="h4">My Orders</Headline>

        {status.started && !status.finished && (
          <div className="relative flex min-h-[12rem] items-center justify-center text-mediumGray">
            <Spinner width="32" />
          </div>
        )}

        {status.finished && !orders?.length && (
          <div
            className="relative flex min-h-[12rem] items-center justify-center"
            role="status"
          >
            You don&#39;t have any orders yet
          </div>
        )}

        {orders?.length >= 1 && (
          <div className="flex flex-col">
            <div className="hidden grid-cols-[2fr_2fr_2fr_2fr_1fr] gap-3 bg-[#3383C51A] px-3 py-3 md:grid">
              {headers.map((header) => {
                return (
                  <h6 key={header} className="text-label">
                    {header}
                  </h6>
                );
              })}
            </div>

            <ul className="flex flex-col">
              {orders.map((order) => {
                return (
                  <li key={order.id + 1}>
                    <OrdersItem order={order} />
                  </li>
                );
              })}
            </ul>

            <div className="flex justify-between gap-3">
              <div>
                {hasPrevious && (
                  <button
                    aria-label="See previous orders"
                    className="text-underline mt-4 text-xs"
                    onClick={getPrevious}
                    type="button"
                  >
                    Previous
                  </button>
                )}
              </div>

              <div>
                {hasNext && (
                  <button
                    aria-label="See next orders"
                    className="text-underline mt-4 text-xs"
                    onClick={getNext}
                    type="button"
                  >
                    Next
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
      </div>
    </AccountLayout>
  );
}
